export const selectOptions = [
  {
    key: '1d',
    label: 'Locate this mine site on a map',
  },
  {
    key: '2d',
    label: 'Locate associated village on a map',
  },
  {
    key: '3d',
    label: 'Review evolution of risk over time at this location',
  },
  {
    key: '4d',
    label: 'Visualise location risk per assessed category',
  },
  {
    key: '5d',
    label: 'Consult the timeline of events reported for this location',
  },
  {
    key: '6d',
    label: 'Evaluate risk against the frequency and severity of incidents at this location',
  },
  {
    key: '7d',
    label: 'Monitor progress of risk mitigation at this location',
  },
  {
    key: '8d',
    label: 'Visualise the current risk management plan for this location',
  },
  {
    key: '9d',
    label: 'Use the stakeholder mapping tool for this location',
  },
];
